import { render, staticRenderFns } from "./SpecialistDashboard.vue?vue&type=template&id=0f29b57a&scoped=true&"
import script from "./SpecialistDashboard.vue?vue&type=script&lang=js&"
export * from "./SpecialistDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistDashboard.vue?vue&type=style&index=0&id=0f29b57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f29b57a",
  null
  
)

export default component.exports